import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { Notebook } from '../../features/personal/NotebookScreen';
import { tabFromParam, type NotebookTab } from '../../features/personal/notebook';

/**
 * `/personal/notebook` = المفكرة (خطة القسم الشخصي ش3).
 *
 * التبويب في `?tab=` لا في الحالة: رابطٌ يُنسخ يفتح التبويب نفسه، وزرّ الرجوع
 * يعمل. وما لا يُعرف يسقط إلى «التدوينات» بلا شاشة خطأ.
 */
export const Route = createFileRoute('/personal/notebook')({
  validateSearch: (search: Record<string, unknown>): { tab?: string } =>
    typeof search['tab'] === 'string' ? { tab: search['tab'] } : {},
  component: NotebookRoute,
});

function NotebookRoute() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <Notebook
      tab={tabFromParam(tab)}
      onTabChange={(next: NotebookTab) => {
        void navigate({ search: { tab: next } });
      }}
    />
  );
}
